import { Component, Input } from '@angular/core';
import { BaseTopDataChartComponent } from '../base-top-data-chart/base-top-data-chart.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AggregationCategorySumWithExtraInfo } from 'src/app/models/api/dashboards.model';

@Component({
  selector: 'app-top-ai-plugins-data-chart',
  templateUrl: './top-ai-plugins-data-chart.component.html',
  styleUrls: ['./top-ai-plugins-data-chart.component.scss'],
})
export class TopAiPluginsDataChartComponent extends BaseTopDataChartComponent {
  @Input() public override seriesData: AggregationCategorySumWithExtraInfo[];

  constructor(
    private readonly _router: Router,
    private readonly _activatedRoute: ActivatedRoute
  ) {
    super();
  }

  public transformPluginTypeText(pluginName: string): string {
    return pluginName.replace('Plugin', '');
  }
}
